module.exports = __webpack_public_path__ + "img/Marca16.75b26bac.jpg";